/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { h } from "preact";
import styled from "styled-components";
import { Loading } from "antd-mobile";
import Icon6 from "@images/6.svg";
const EmptoyList: any = ({loading,list}: any) => {
    return (<Container>
        {loading==false&&list.length==0&&<Icon src={Icon6} />}
        <div style={{ color: "#B0A6F4", fontSize: 18 }}>
                {loading && <MoreWrap>
                    <Loading color="currentColor" />
                </MoreWrap>}
        </div>
    </Container>)
}

export default EmptoyList;

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
 `;
 const MoreWrap = styled.div`
    width:750px;
    padding:56px;
    border-radius:5px;
    display: flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
`;
const Icon=styled.img`
    margin-top: 250px;
    width: 338px;
    height: 248px;
`